import React from "react";
import { Card, CardContent, Typography, Button, Grid, CardMedia } from "@mui/material";
import './SubquestionCard.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MathPreview from "../../../CustomInputFields/MathPreview/MathPreview";

const SubquestionCard = ({ subquestion, handleDelete, handleUpdate }) => {
  const { id, body, image, correct_answer, choices, grade } = subquestion;

  return (
    <Card className="subquestion-card">
        <CardContent>
            <Typography className="subquestion-title">
            {/* Subquestion: {body} */}
            <MathPreview text={body} />

            </Typography>
            {image && (
            <CardMedia
                component="img"
                className="question-image"
                image={`${process.env.REACT_APP_API_BASE_IMAGE_URL}${image}`}
                alt="Question Image"
            />
            )}
            <Typography className="subquestion-correct-answer" gutterBottom>
               {correct_answer? `correct_answer: ${correct_answer}` : ''}
            </Typography>
            <Typography className="grade-text">
                Grade: {Number.isInteger(grade) ? grade : grade?.toFixed(1)}
            </Typography>



            {choices?.length > 0 && (
            <Typography className="subquestion-title">
                Choices:
            </Typography>
            )}
            {choices?.map((choice, index) => (
            <Typography key={index} className="choice-item">
                {/* {choice.number}. {choice.value} */}
                {<MathPreview text={`${choice.number}.   ${choice.value}`} />}
            </Typography>
            ))}

            <div className="subquestion-actions">
                <Button
                    className="primary-button"
                    onClick={() => handleUpdate(id)}
                >
                    <EditIcon 
                        className="edit-icon"
                    />
                    Edit
                </Button>
                <Button
                    className="delete-button"
                    onClick={() => handleDelete(id)}
                >
                    <DeleteIcon 
                        className="delete-icon"
                    />
                    Delete
                            </Button>
            </div>
        </CardContent>
        </Card>

  );
};

export default SubquestionCard;
